var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84258 2.75625C3.24261 2.75625 2.75623 3.24262 2.75623 3.84259V16.2921L5.12601 13.9223C5.25221 13.7961 5.42337 13.7252 5.60184 13.7252H16.1574C16.7574 13.7252 17.2437 13.2389 17.2437 12.6389V3.84259C17.2437 3.24262 16.7574 2.75625 16.1574 2.75625H3.84258ZM1.4104 3.84259C1.4104 2.49934 2.49932 1.41042 3.84258 1.41042H16.1574C17.5006 1.41042 18.5896 2.49934 18.5896 3.84259V12.6389C18.5896 13.9821 17.5006 15.0711 16.1574 15.0711H5.88057L2.55914 18.3925C2.36669 18.5849 2.07725 18.6425 1.8258 18.5384C1.57435 18.4342 1.4104 18.1888 1.4104 17.9167V3.84259Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8292 4.92233C10.8292 4.55414 10.5307 4.25566 10.1625 4.25566C9.79433 4.25566 9.49585 4.55414 9.49585 4.92233V8.25566C9.49585 8.62385 9.79433 8.92233 10.1625 8.92233C10.5307 8.92233 10.8292 8.62385 10.8292 8.25566V4.92233ZM10.1625 10.5829C9.79433 10.5829 9.49585 10.8814 9.49585 11.2496C9.49585 11.6178 9.79433 11.9162 10.1625 11.9162H10.1708C10.539 11.9162 10.8375 11.6178 10.8375 11.2496C10.8375 10.8814 10.539 10.5829 10.1708 10.5829H10.1625Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.ab28d2c29ebe0f1639d9d32af0ab0c86.svg";
export { ForwardRef as ReactComponent };